module["exports"] = [
  "074## ######",
  "075## ######",
  "076## ######",
  "077## ######",
  "078## ######",
  "079## ######"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_GB/cell_phone/formats.js
 ** module id = 409
 ** module chunks = 0
 **/